import type { IconData } from '@stacksjs/iconify-core'

export const basicUiForbidden: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-6.305 4.17A4.5 4.5 0 0 1 3.83 6.305zm2.475-2.475L6.305 3.83a4.5 4.5 0 0 1 5.865 5.865\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiForbidden
